export default {
  installTitle: 'Установить приложение?',
  installDescription: 'Для быстрого доступа и работы в режиме офлайн приложение «Эффективный город» можно установить на устройство',
}